import React from 'react'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import cn from 'classnames'
import LazyImage from '../../components/LazyImage/LazyImage'
import { useEffect } from 'react'

const goals = ['Lose weight', 'Maintain weight', 'Gain weight']

export default function PlanListing({ plans }) {
  const [selectedGoal, setSelectedGoal] = useState(goals[0])
  const [existingGoals, setExistingGoals] = useState([])

  useEffect(() => {
    const filteredGoals = []
    plans.map(
      ({ goal }) => !filteredGoals.includes(goal) && filteredGoals.push(goal),
    )
    setExistingGoals(filteredGoals)
  }, [plans])

  return (
    <div
      className={`
      my-24
      bg-BgSub
      pb-24 pt-24 text-center md:my-40
      md:pb-40 lg:my-72 lg:pb-56 lg:pt-36
      xl:my-96 xl:pb-72
    `}
    >
      <div className="o-width-limiter">
        {existingGoals.length > 1 && (
          <Switcher
            onChange={setSelectedGoal}
            selected={selectedGoal}
            existingGoals={existingGoals}
          />
        )}
        <ul className="gap-8 md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {plans
            .filter(({ goal: planGoal }) => planGoal === selectedGoal)
            .map(({ image, name, text, id }) => {
              return (
                <li key={id}>
                  <LazyImage
                    src={image.url}
                    height={100}
                    width={100}
                    alt=""
                    className="mt-auto xxl:w-2/5"
                  />
                  <h3 className="type-med-fat -mt-4 mb-8 md:mb-16 md:mt-0">
                    {name}
                  </h3>
                  <p className="type-default mb-16 leading-body">{text}</p>
                </li>
              )
            })}
        </ul>
      </div>
    </div>
  )
}

PlanListing.propTypes = {
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.object,
      name: PropTypes.string,
      text: PropTypes.string,
      goal: PropTypes.oneOf(goals),
      id: PropTypes.string,
    }),
  ),
}

function Switcher({ onChange, selected, existingGoals }) {
  const buttonText = {
    'Lose weight': (
      <FormattedMessage id="goal_losing" defaultMessage="Losing weight" />
    ),
    'Maintain weight': (
      <FormattedMessage
        id="goal_maintaining"
        defaultMessage="Maintaining weight"
      />
    ),
    'Gain weight': (
      <FormattedMessage id="goal_gaining" defaultMessage="Gaining weight" />
    ),
  }

  return (
    <div className="pb-24 lg:pb-36">
      <p className="type-small mb-8">
        <FormattedMessage
          id="planspage_showplans_text"
          defaultMessage="Show plans for:"
        />
      </p>
      {goals.map((goal) => {
        if (existingGoals.includes(goal))
          return (
            <button
              onClick={() => onChange(goal)}
              aria-expanded={selected === goal}
              key={goal}
              className={cn(
                'text-BrandDark',
                'rounded-full',
                'transition',
                'px-12 pb-2 pt-4 lg:px-16 lg:pb-6 lg:pt-8',
                'mb-4 md:mb-0',
                'border-1 border-transparent',
                'type-14-demibold md:type-14-demibold-caps lg:type-17-demibold-caps',
                {
                  'border-BorderSub bg-Bg text-Type shadow-elevated':
                    selected === goal,
                },
              )}
            >
              {buttonText[goal]}
            </button>
          )
      })}
    </div>
  )
}

Switcher.propTypes = {
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.oneOf(goals),
  existingGoals: PropTypes.array,
}
